










import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SwitchlangHeader extends Vue {
  @Prop({ default: false }) readonly isMobile!: boolean;

  private langs = "en";

  get languageMobile() {
    return this.langs == "en" ? "English" : "ภาษาไทย";
  }

  created() {
    this.langs = this.langs === this.$i18n.locale ? "th" : "en";
  }

  @Watch("$i18n.locale")
  langsChanged() {
    if (this.$i18n.locale == "en") {
      this.langs = "th";
    } else {
      this.langs = "en";
    }
  }

  public Setlocate() {
    if (this.langs == "en") {
      this.$i18n.locale = "en";
      this.langs = "th";
    } else {
      this.$i18n.locale = "th";
      this.langs = "en";
    }
  }
}
